import { Routes } from '@angular/router';
import { PublicLayout } from './layouts/public-layout/public-layout';
import { AuthGuard } from './core/guards/auth.guard';
import { ROUTES } from '@shared/constants/routes';
import { candidateRoutes } from './core/routes/candidate.routes';
import { employerRoutes } from './core/routes/employer.routes';

export const routes: Routes = [
  {
    path: ROUTES.CANDIDATE_LOGGED_HOME,
    pathMatch: 'prefix',
    canActivate: [AuthGuard],
    children: candidateRoutes,
  },
  {
    path: ROUTES.EMPLOYER_LOGGED_HOME,
    pathMatch: 'prefix',
    canActivate: [AuthGuard],
    children: employerRoutes,
  },
  {
    path: ROUTES.CANDIDATE,
    component: PublicLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/public/signup/signup').then((m) => m.Signup),
      },
      {
        path: ROUTES.REGISTRATION,
        loadComponent: () =>
          import('./features/public/candidate/registration/registration').then((m) => m.Registration),
      },
      {
        path: ROUTES.REGISTRATION_STARTED,
        loadComponent: () =>
          import('./shared/ui/registration-started/registration-started').then(
            (m) => m.RegistrationStarted
          ),
      },
      {
        path: ROUTES.REGISTRATION_INTERMEDIATE,
        loadComponent: () =>
          import('./features/public/candidate/registration-intermediate/registration').then(
            (m) => m.CandidateRegistrationIntermediate
          ),
      },
      {
        path: ROUTES.REGISTRATION_COMPLETED,
        loadComponent: () =>
          import('./shared/ui/registration-completed/registration-completed').then(
            (m) => m.RegistrationCompleted
          ),
      },
    ],
  },
  {
    path: ROUTES.EMPLOYER,
    component: PublicLayout,
    children: [
      {
        path: '',
        loadComponent: () => import('./features/public/signup/signup').then((m) => m.Signup),
      },
      {
        path: ROUTES.REGISTRATION,
        loadComponent: () =>
          import('./features/public/employer/registration/registration').then((m) => m.Registration),
      },
      {
        path: ROUTES.REGISTRATION_STARTED,
        loadComponent: () =>
          import('./shared/ui/registration-started/registration-started').then(
            (m) => m.RegistrationStarted
          ),
      },
      {
        path: ROUTES.REGISTRATION_INTERMEDIATE,
        loadComponent: () =>
          import('./features/public/employer/registration-intermediate/registration').then(
            (m) => m.EmployerRegistrationIntermediate
          ),
      },
      {
        path: ROUTES.REGISTRATION_COMPLETED,
        loadComponent: () =>
          import('./shared/ui/registration-completed/registration-completed').then(
            (m) => m.RegistrationCompleted
          ),
      },
    ],
  },
  {
    path: ROUTES.ABOUT_US,
    component: PublicLayout,
    pathMatch: 'full',
    children: [
      { path: '', loadComponent: () => import('./features/public/about-us/about-us').then((m) => m.AboutUs) },
    ],
  },
  {
    path: ROUTES.COOKIE_POLICY,
    component: PublicLayout,
    pathMatch: 'full',
    children: [
      { path: '', loadComponent: () => import('./features/public/cookie-policy/cookie-policy').then((m) => m.CookiePolicy) },
    ],
  },
  {
    path: ROUTES.PRIVACY_POLICY,
    component: PublicLayout,
    pathMatch: 'full',
    children: [
      { path: '', loadComponent: () => import('./features/public/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy) },
    ],
  },
  {
    path: '',
    component: PublicLayout,
    pathMatch: 'full',
    children: [
      { path: '', loadComponent: () => import('./features/public/home/home').then((m) => m.Home) },
    ],
  },
  { path: '**', redirectTo: '' },
];
